import { render, staticRenderFns } from "./SolicitudesConfiguration.vue?vue&type=template&id=2db43e8b&scoped=true"
import script from "./SolicitudesConfiguration.vue?vue&type=script&lang=js"
export * from "./SolicitudesConfiguration.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesConfiguration.vue?vue&type=style&index=0&id=2db43e8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db43e8b",
  null
  
)

export default component.exports